// Mensagens rápidas do chat: variáveis ({nome}, {meu_nome}, {empresa}) e sugestões iniciais.

export interface QuickReply {
    id: number;
    company_id: number;
    /** Nulo = mensagem da empresa (todos veem, a gestão edita). */
    owner_id: string | null;
    title: string;
    body: string;
    position: number;
}

export const QUICK_REPLY_VARIABLES: Array<{ token: string; label: string }> = [
    { token: '{nome}', label: 'Primeiro nome do lead' },
    { token: '{meu_nome}', label: 'Seu nome' },
    { token: '{empresa}', label: 'Nome da empresa' },
];

export const DEFAULT_QUICK_REPLIES: Array<{ title: string; body: string }> = [
    { title: 'Saudação', body: 'Olá, {nome}! Como posso ajudar?' },
    { title: 'Vou verificar', body: 'Tudo bem! Vou verificar e já te retorno.' },
    { title: 'Pedir detalhes', body: 'Pode me passar mais detalhes, por favor?' },
    { title: 'Horário de atendimento', body: 'Nosso horário de atendimento é de segunda a sexta, das 09h às 18h.' },
    { title: 'Agradecimento', body: 'Obrigado pelo contato, {nome}!' },
];

const primeiroNome = (nome?: string | null) => (nome || '').trim().split(/\s+/)[0] || '';

/** Troca as variáveis pelos dados do atendimento. Sem o dado, a variável some sem deixar espaço sobrando. */
export function applyQuickReplyVariables(body: string, ctx: { leadName?: string | null; userName?: string | null; companyName?: string | null }): string {
    return body
        .replace(/\{nome\}/gi, primeiroNome(ctx.leadName))
        .replace(/\{meu_nome\}/gi, primeiroNome(ctx.userName))
        .replace(/\{empresa\}/gi, (ctx.companyName || '').trim())
        .replace(/ +([,.!?;:])/g, '$1')
        .replace(/[ \t]{2,}/g, ' ')
        .trim();
}

/** Da empresa primeiro, depois as pessoais; dentro de cada grupo, por posição e título. */
export function sortQuickReplies(list: QuickReply[]): QuickReply[] {
    return [...list].sort((a, b) =>
        (a.owner_id === null ? 0 : 1) - (b.owner_id === null ? 0 : 1)
        || a.position - b.position
        || a.title.localeCompare(b.title, 'pt-BR'));
}

export function filterQuickReplies(list: QuickReply[], query: string): QuickReply[] {
    const q = query.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
    if (!q) return list;
    const norm = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    return list.filter(r => norm(r.title).includes(q) || norm(r.body).includes(q));
}
